export default "__VITE_ASSET__DQuY4jdP__"